import { render, staticRenderFns } from "./BlocSmsCreate.vue?vue&type=template&id=739c1bb1"
import script from "./BlocSmsCreate.vue?vue&type=script&lang=ts"
export * from "./BlocSmsCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports